export const NEXTCLOUD_CONNECT_START = "NEXTCLOUD_CONNECT_START"
export const NEXTCLOUD_CONNECT_POLL = "NEXTCLOUD_CONNECT_POLL"
export const NEXTCLOUD_CONNECT_SUCCESS = "NEXTCLOUD_CONNECT_SUCCESS"
export const NEXTCLOUD_CONNECT_FAIL = "NEXTCLOUD_CONNECT_FAIL"

